<template>
    <div class="contacts-page">
    <!-- <div :class="isPublicRoute() == true ? 'adjustment contacts':'contacts'"> -->
        <div class="page-hero">
        <div class="page-hero-context">
          <div class="page-hero-text">Contact Information</div>
          <div class="page-hero-subtext">We would like to hear more from you.</div>
        </div>
      </div>

      <div class="contacts-section">
                <div class="contact-details">
                <p>If you would like to know about our service or get customer care support, please write to us using the following emails.</p>
                <div class="contact-items">
                    <div class="contact-item">
                        <div class="contact-text">info@vocation.mw</div>            
                        <div class="contact-text">support@vocation.mw</div>            
                    </div>
                   
                </div>
                <p>We hope to see you fully experience Vocation's tools and services.<br/><b>Happy job searching and recruitment!</b></p>
            </div>
            <div class="branding">
                <NavLogo class="logo"/>
            </div>
       </div>
       <ContactInformation/>

    </div>
</template>
<script>
  import NavLogo from '@/components/IconComponents/NavLogo.vue';
  import ContactInformation from '@/components/ContactInformation.vue';
  export default{
    components:{
       NavLogo, ContactInformation
    },
    data(){
        return{
            email: process.env.VUE_APP_CONTACT_EMAIL,
            phone: process.env.VUE_APP_CONTACT_PHONE,
        }
    },
     mounted(){
       window.scrollTo({top: 0,behavior: 'smooth'});
    },
     methods:{
        isPublicRoute(){
            return this.$route.name == 'contact-us' ? true : false
        }
    }
}
</script>
<style scoped>
     .heading, p, li, .contact-text{
        font-family: var(--body-font);
    }

  .heading{
        margin-top:-1rem;
        color:var(--intro);
        margin-bottom:1.2rem;
        font-size:2rem;
        font-family:var(--job-title-font);
         
    }

    .adjustment{
        margin-top: 2.6rem!important;
   }

   .contacts{
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap:2rem;
   }

   .contact-items{
    margin-bottom: 1rem;
   }

   

   .contact-item:first-child{
    margin-bottom: 0.7rem;
   }

    .theme-card{
    border-radius:16px!important;
    padding:2rem;
    min-height: 25rem;
    /* background: url('../assets/images/blurs.png') fixed no-repeat center/90%, var(--intro-background); */
   }

   .contact-details{
    grid-column: 1/2;
   }

   .branding{
    flex:1;
    display: flex;
    justify-content: center;
    grid-column:2/3;
    /* align-self: center; */
    
   }

   .contact-icon{
    color:var(--secondary);
   }

   .logo{
    margin-top:1rem;
    height:9rem;
    width: 22rem;
    justify-self: center;
    
   }

    .contacts-page{
      background-color: var(--info-page-background);
      margin:-2rem 0rem;
      display: grid;
    }

    .page-hero-subtext{
     color:white;
  }

     .page-hero-context{
      justify-self: center;
      align-self: center;
      margin-top: 3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

     .page-hero-text{
      
      color:white;
      font-size:3rem;
      font-family: var(--job-title-font);
    }

     .page-hero{
      background:url('../assets/images/about5.jpg') fixed, rgb(13, 161, 215);
      background-blend-mode:darken;
      background-size: cover;
      background-repeat: no-repeat;
      background-position:0% 85%;
      min-height:20rem;
      display: grid;
      margin-bottom:2rem;
    }

    .contacts-section{
        display: flex;
        margin:1rem;
    }

   
    @media(max-width: 768px){
        .heading{
          margin-top:0rem;
            font-size:2rem;
             margin-bottom:0.8rem;
             line-height:2rem;
        }

        .policy-heading{
          font-size:1rem;
        }

        p, .contact-text{
          font-size:0.9rem;
        }

        .contact-icon{
        margin-top:0.2rem;
        height: 1rem;
    }

         .branding{
            display: none;
  
         }

         .contacts{
            /* display: grid; */
            grid-template-columns: 1fr;
            /* column-gap:2rem; */
        }

          .contact-item{
 
            align-items: flex-start;
        
        }

         .page-hero{
      background:url('../assets/images/about5.jpg'), rgb(13, 161, 215);
      background-blend-mode:darken;
      background-size: cover;
      background-repeat: no-repeat;
      background-position:70% 50%;
      min-height:17rem;
      display: grid;
       margin-bottom:1rem;
    }

    .page-hero-text{
      font-size:1.8rem;
    }

    .page-hero-subtext{
      font-size:0.7rem;
      margin-top:-0.4rem;
    }

    .page-hero-context{
      margin-top:3.6rem;
    }


    }
</style>